import { alpha, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  fileUploadWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.3),
    padding: theme.spacing(2, 2, 2, 3),
    borderRadius: "8px",
  },
  ellipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  initialText: {
    fontSize: "14px",
    lineHeight: "24px",
    color: theme.custom.color.mortar,
    width: "300px",
    textAlign: "left",
  },
  uploadedText: {
    color: theme.custom.color.black,
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    "& .MuiSvgIcon-root": {
      color: theme.custom.color.apple,
      marginRight: theme.spacing(1.5),
    },
    "& span": {
      width: "280px",
      textAlign: "left",
    },
  },
  fileUploadWrap: {
    position: "relative",
    "& input:hover+ .MuiButton-root": {
      borderColor: theme.custom.linkHover.color,
      color: theme.custom.linkHover.color,
    },
    "& input:hover+ .MuiButton-root.Mui-disabled": {
      color: theme.custom.color.gainsboro,
      borderColor: theme.custom.color.gainsboro,
    },
  },
  fileUpload: {
    opacity: 0,
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    cursor: "pointer",
  },
  disabled: {
    cursor: "not-allowed",
  },
}));
